const accessBlockedRu = {
  'accessBlocked': {
    'title': {
      'blocked': 'Доступ заблокирован',
      'not_possible': 'Операция невозможна',
    },
    'description': {
      'recover': 'Введены неверные данные при восстановлении доступа.',
      'password': 'Было совершено пять неуспешных попыток входа в личный кабинет.',
      'sms': 'Превышено количество попыток запроса кода по смс.',
      'scratch': 'Было совершено пять неуспешных попыток ввода кода со скретч-карты.',
    },
    'tryAgainAfter': {
      'default': 'Вы сможете попробовать снова через:',
    },
  },
};

export default accessBlockedRu;
